import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ScrollIntoViewIds } from './scroll-into-view-ids';

@Injectable({ providedIn: 'root' })
export class ScrollIntoViewService {
  private readonly scrollIntoViewSubject = new Subject<ScrollIntoViewIds>();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  readonly scrollIntoView$ = this.scrollIntoViewSubject.asObservable();

  scrollToElement(id: ScrollIntoViewIds): void {
    this.scrollIntoViewSubject.next(id);
  }
}
